import {
  FormControlLabel,
  FormHelperText,
  Paper,
  Typography,
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import Image from 'components/Image';
import { HOST_API } from 'config';
import {
  FormsErrorDataType,
  SelectedGateways,
} from 'containers/dashboard/Forms/FormListingType';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from './elements';

interface Props {
  methods: SelectedGateways[];
  onChangeGatewayCheck: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
    gatewayId: string
  ) => void;
  mode: boolean;
  stateError: Partial<FormsErrorDataType>;
  allowRecurringForDonation: boolean;
}

const PaymentMethods: React.FC<Props> = ({
  methods,
  mode,
  onChangeGatewayCheck,
  stateError,
  allowRecurringForDonation,
}) => {
  const { t } = useTranslation();
  const testPaymentGateways = methods.filter(
    testGateway => testGateway.test_keys_configured === true
  );

  const livePaymentGateways = methods.filter(
    testGateway => testGateway.live_keys_configured === true
  );

  if (mode) {
    methods = testPaymentGateways;
  } else {
    methods = livePaymentGateways;
  }

  const currency = methods.find(method => method.is_selected)?.settings
    .payment_currency;

  return (
    <Container>
      {methods.length
        ? methods.map(method => (
            <Paper
              key={method._id}
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
                padding: '10px 10px 10px 10px',
                margin: '10px 0px 10px 0px',
                border: '1px solid rgba(145, 158, 171, 0.24)',
              }}
            >
              <FormControlLabel
                name='selectedGateways'
                control={
                  <Checkbox
                    onChange={(event, checked) =>
                      onChangeGatewayCheck(event, checked, method._id)
                    }
                    checked={method.is_selected}
                    disabled={
                      (currency === undefined
                        ? false
                        : currency !== method.settings.payment_currency) ||
                      (allowRecurringForDonation && method.name !== 'stripe')
                    }
                  />
                }
                label={method.label}
              />

              <div>
                <Image
                  maxHeight='1rem'
                  src={HOST_API + '/' + method.images.logo}
                />
              </div>
            </Paper>
          ))
        : `${t('no_gateway_found')} ${t('in')} ${
            mode ? t('test_mode') : t('live_mode')
          }`}

      {stateError.selectedGateways &&
        stateError.selectedGateways.length > 0 && (
          <FormHelperText error={true}>
            {stateError.selectedGateways}
          </FormHelperText>
        )}
      {currency && (
        <Typography className='currency-notice' typography='caption'>
          *{t('one_currency_gateway')}
        </Typography>
      )}
    </Container>
  );
};

export default React.memo(PaymentMethods);
